"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginApi = void 0;
var runtime = __importStar(require("../runtime"));
var models_1 = require("../models");
/**
 *
 */
var LoginApi = /** @class */ (function (_super) {
    __extends(LoginApi, _super);
    function LoginApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginApi.prototype.buildUrl = function (path, queryParameters) {
        var query = this.configuration.queryParamsStringify(queryParameters);
        return "".concat(this.configuration.basePath).concat(path).concat(query && "?".concat(query));
    };
    LoginApi.prototype.getInternalCallInfoForActivateEmailLoginCheckAccount = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/activate-email-login/check-account"
        };
    };
    LoginApi.prototype.getUrlForActivateEmailLoginCheckAccountByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForActivateEmailLoginCheckAccount(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Test if the user\'s account can be changed to login type email
     */
    LoginApi.prototype.activateEmailLoginCheckAccountRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForActivateEmailLoginCheckAccount(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ActivateEmailLoginCheckAccountRequestPayloadToJSON)(requestParameters.activateEmailLoginCheckAccountRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ActivateEmailLoginCheckAccountResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Test if the user\'s account can be changed to login type email
     */
    LoginApi.prototype.activateEmailLoginCheckAccount = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.activateEmailLoginCheckAccountRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForActivateEmailLoginConfirm = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/activate-email-login/confirm"
        };
    };
    LoginApi.prototype.getUrlForActivateEmailLoginConfirmByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForActivateEmailLoginConfirm(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Activate login with email for this account
     */
    LoginApi.prototype.activateEmailLoginConfirmRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForActivateEmailLoginConfirm(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ActivateEmailLoginConfirmRequestPayloadToJSON)(requestParameters.activateEmailLoginConfirmRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ActivateEmailLoginConfirmResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Activate login with email for this account
     */
    LoginApi.prototype.activateEmailLoginConfirm = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.activateEmailLoginConfirmRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForDoCallcenterADFSLogin = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/cc/login/adfs"
        };
    };
    LoginApi.prototype.getUrlForDoCallcenterADFSLoginByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForDoCallcenterADFSLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * login a callcenter agent using an ADFS access token
     */
    LoginApi.prototype.doCallcenterADFSLoginRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, token, tokenString, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDoCallcenterADFSLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("ADFSBearerToken", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                            }
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CallCenterLoginResponsePayloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * login a callcenter agent using an ADFS access token
     */
    LoginApi.prototype.doCallcenterADFSLogin = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doCallcenterADFSLoginRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForDoCallcenterLogin = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/cc/login"
        };
    };
    LoginApi.prototype.getUrlForDoCallcenterLoginByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForDoCallcenterLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * login a callcenter agent
     */
    LoginApi.prototype.doCallcenterLoginRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDoCallcenterLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PasswordCredentialsToJSON)(requestParameters.passwordCredentials),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CallCenterLoginResponsePayloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * login a callcenter agent
     */
    LoginApi.prototype.doCallcenterLogin = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doCallcenterLoginRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForDoCallcenterLoginByLink = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/cc/login/link"
        };
    };
    LoginApi.prototype.getUrlForDoCallcenterLoginByLinkByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForDoCallcenterLoginByLink(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * login a callcenter agent from the ERP system using a link
     */
    LoginApi.prototype.doCallcenterLoginByLinkRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDoCallcenterLoginByLink(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: path,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.CallcenterByLinkCredentialsToJSON)(requestParameters.callcenterByLinkCredentials),
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * login a callcenter agent from the ERP system using a link
     */
    LoginApi.prototype.doCallcenterLoginByLink = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doCallcenterLoginByLinkRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForForgotPasswordRequestEmail = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/forgot-password/request-email"
        };
    };
    LoginApi.prototype.getUrlForForgotPasswordRequestEmailByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForForgotPasswordRequestEmail(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * request a password reset email
     */
    LoginApi.prototype.forgotPasswordRequestEmailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForForgotPasswordRequestEmail(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ForgotPasswordRequestEmailRequestPayloadToJSON)(requestParameters.forgotPasswordRequestEmailRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ForgotPasswordRequestEmailResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * request a password reset email
     */
    LoginApi.prototype.forgotPasswordRequestEmail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.forgotPasswordRequestEmailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForForgotPasswordSetNewPassword = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/forgot-password/set-new-password"
        };
    };
    LoginApi.prototype.getUrlForForgotPasswordSetNewPasswordByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForForgotPasswordSetNewPassword(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Set a new account password after receiving a password reset link by email.
     */
    LoginApi.prototype.forgotPasswordSetNewPasswordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForForgotPasswordSetNewPassword(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ForgotPasswordSetNewPasswordRequestPayloadToJSON)(requestParameters.forgotPasswordSetNewPasswordRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ForgotPasswordSetNewPasswordResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Set a new account password after receiving a password reset link by email.
     */
    LoginApi.prototype.forgotPasswordSetNewPassword = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.forgotPasswordSetNewPasswordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForForgotPasswordValidateToken = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/forgot-password/validate-token"
        };
    };
    LoginApi.prototype.getUrlForForgotPasswordValidateTokenByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForForgotPasswordValidateToken(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Check if the token is still valid.
     */
    LoginApi.prototype.forgotPasswordValidateTokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForForgotPasswordValidateToken(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ForgotPasswordValidateTokenRequestPayloadToJSON)(requestParameters.forgotPasswordValidateTokenRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ForgotPasswordValidateTokenResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Check if the token is still valid.
     */
    LoginApi.prototype.forgotPasswordValidateToken = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.forgotPasswordValidateTokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForGetAnonymousToken = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/anonymous"
        };
    };
    LoginApi.prototype.getUrlForGetAnonymousTokenByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetAnonymousToken(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get a anonymous token
     */
    LoginApi.prototype.getAnonymousTokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetAnonymousToken(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.xEcSystem !== undefined && requestParameters.xEcSystem !== null) {
                            headerParameters['x-ec-system'] = String(requestParameters.xEcSystem);
                        }
                        return [4 /*yield*/, this.request({
                                path: path,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TokensFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get a anonymous token
     */
    LoginApi.prototype.getAnonymousToken = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAnonymousTokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForGetReturningUsersToken = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login/returning"
        };
    };
    LoginApi.prototype.getUrlForGetReturningUsersTokenByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetReturningUsersToken(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get a fresh token (autologin or anonymous, depending on the mastertoken
     */
    LoginApi.prototype.getReturningUsersTokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetReturningUsersToken(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TokensFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get a fresh token (autologin or anonymous, depending on the mastertoken
     */
    LoginApi.prototype.getReturningUsersToken = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReturningUsersTokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForLogin = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login"
        };
    };
    LoginApi.prototype.getUrlForLoginByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * login a customer
     */
    LoginApi.prototype.loginRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForLogin(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CredentialsToJSON)(requestParameters.credentials),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LoginResponsePayloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * login a customer
     */
    LoginApi.prototype.login = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loginRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForLogout = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/logout"
        };
    };
    LoginApi.prototype.getUrlForLogoutByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForLogout(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * logout a use or a callcenter agent
     */
    LoginApi.prototype.logoutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForLogout(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'text/plain';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.body,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TokensFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * logout a use or a callcenter agent
     */
    LoginApi.prototype.logout = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.logoutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginApi.prototype.getInternalCallInfoForShowLoginStatus = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/login"
        };
    };
    LoginApi.prototype.getUrlForShowLoginStatusByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForShowLoginStatus(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * describe the login token of the user
     */
    LoginApi.prototype.showLoginStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForShowLoginStatus(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * describe the login token of the user
     */
    LoginApi.prototype.showLoginStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.showLoginStatusRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return LoginApi;
}(runtime.BaseAPI));
exports.LoginApi = LoginApi;
//# sourceMappingURL=LoginApi.js.map